import { Modal } from 'react-responsive-modal'
import 'react-responsive-modal/styles.css'
import style from './modal.module.scss'
import closeIcon from '../../assets/images/close-dark.svg'

export interface CommonModalProps {
  open: boolean
  onCloseModal: () => void
  children: JSX.Element
  title?: string
  modalWidth?: string
}

const CommonModal = ({
  open,
  onCloseModal,
  children,
  title,
  modalWidth = '700px',
}: CommonModalProps) => {
  return (
    <Modal
      styles={{
        modal: {
          width: 'calc(100% - 40px)',
          maxWidth: modalWidth,
        },
      }}
      open={open}
      onClose={onCloseModal}
      center={true}
      showCloseIcon={false}
    >
      <div className={style.modal}>
        <header className={style.modal__header}>
          {title}

          <img src={closeIcon} onClick={onCloseModal} alt="close" />
        </header>
        <div className={style.modal__content} onClick={e => e.stopPropagation()}>
          {children}
        </div>
      </div>
    </Modal>
  )
}
export default CommonModal
